import { computed } from "mobx"
import { observer } from "mobx-react"
import { Flex, Typography } from "antd"

import { ConvertPairsItemType } from "@src/pages/convert/classes/ConvertPairsCollection"
import { ConvertCurrency } from "@src/pages/convert/classes/ConvertProcess"
import { ConvertFormTimer } from "@src/pages/convert/ui/ConvertFormTimer"
import { ConvertTokenResponse } from "@src/shared/api/generated"

type Props = {
  fetchRate: () => Promise<void>
  from: ConvertCurrency | undefined
  rates: ConvertTokenResponse
  to: ConvertCurrency | undefined
}
export const ConvertFormRates = observer(
  ({ fetchRate, from, rates, to }: Props) => {
    const rate = computed(
      () =>
        `1 ${from?.symbol_alias ?? from?.symbol} = ${rates.rate} ${to?.symbol_alias ?? to?.symbol}`,
    ).get()

    return (
      <Flex gap={4} vertical>
        <Flex gap={16}>
          <Typography.Text strong>Exchange rate:</Typography.Text>
          <Typography.Text style={{ opacity: 0.65 }}>{rate}</Typography.Text>
        </Flex>
        <Flex gap={16}>
          <Typography.Text strong>Will refresh in:</Typography.Text>
          <ConvertFormTimer
            expTime={rates.expires_at as string}
            preFetch={fetchRate}
          />
        </Flex>
      </Flex>
    )
  },
)
